
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType = typeof DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType[keyof typeof DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
